import React from 'react'
import './Features.css';
const Card = (props) => {
  return (
    <div>
        <div className="demo btn_shadow">
              <img src={props.image } alt='' />
              <h2>{props.title}</h2>
              <p>{props.desc}</p>
            <a href="">
                <i className="fas fa-arrow-right">
                </i>
              </a>

            </div>
    </div>
  )
}

export default Card